import { createFileRoute } from "@tanstack/react-router";
import { SuperUsersTable } from "@/components/admin/SuperUserTable/SuperUsersTable";
import { checkSuperUserPermission } from "@/lib/utils";

export const Route = createFileRoute("/_superuser/admin/superusers")({
  component: SuperUsersPage,
  beforeLoad: () => {
    checkSuperUserPermission("superuser-management");
  },
});

function SuperUsersPage() {
  return <SuperUsersTable />;
}
